import { render, staticRenderFns } from "./FooterCmp.vue?vue&type=template&id=46f20d24&scoped=true&"
import script from "./FooterCmp.vue?vue&type=script&lang=js&"
export * from "./FooterCmp.vue?vue&type=script&lang=js&"
import style0 from "./FooterCmp.vue?vue&type=style&index=0&id=46f20d24&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46f20d24",
  null
  
)

export default component.exports